import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconBrandSuperhuman } from '@tabler/icons-react';
import { Alert } from 'antd';
import { BetaSchemaForm, ProFormColumnsType } from '@ant-design/pro-components';
import { renderMultiListToTagsWithLink } from '@ohpen/enso-ui';

import { FieldType, FirmGetById } from '@pmp/api';
import { exclusivesRedirectPath } from '@pmp/utils';

import { TabProps } from '../interfaces';
import { TabContent } from './TabContent';
import { CrudFormCard } from './CrudFormCard';

export const ExclusivesTab: React.FC<TabProps> = ({ form, mode, selectsOptions }) => {
  const { t } = useTranslation();

  const columns: ProFormColumnsType<FirmGetById, 'text'>[] = useMemo(
    () => [
      {
        title: t('lender.firms.labels.exclusiveProductSets'),
        dataIndex: ['exclusives'],
        valueType: 'select',
        readonly: true,
        render: (dom, entity) => renderMultiListToTagsWithLink(dom, entity, exclusivesRedirectPath),
        fieldProps: {
          mode: 'multiple',
          options: selectsOptions[FieldType.EXCLUSIVITY_SETS],
        },
        colProps: { span: 12 },
        tooltip: t('lender.firms.labels.exclusiveProductSetsTooltip'),
      },
    ],
    [selectsOptions, t],
  );

  return (
    <TabContent>
      <Alert message={t('lender.firms.labels.exclusivesAlert')} type="info" showIcon />
      <CrudFormCard icon={<IconBrandSuperhuman />} title={t('lender.firms.labels.exclusives')}>
        <BetaSchemaForm<FirmGetById> form={form} layoutType="Embed" columns={columns} submitter={false} />
      </CrudFormCard>
    </TabContent>
  );
};
